export enum ExpensePolicyTypeValue {
  UNTOUCHABLE = "untouchable",
  TOUCHABLE_LESS = "touchable_less",
  TOUCHABLE_MORE_LESS = "touchable_more_less",
  AMOUNT_MAXIMUM = "amount_maximum",
}
